import React, { useState } from 'react';
import { ExpenseReengage } from '../../../../Constants/Constants';


const AnyApply = ({ onNext, answers, stepKey }) => {
  const [error, setError] = useState('');
  const [selection, setSelection] = useState(answers[stepKey] || []);
  
  const isOtherSelected = selection.some(item => item === '414' || (typeof item === 'string' && item.startsWith('414:')));
  const otherValue = isOtherSelected ? 
    selection.find(item => typeof item === 'string' && item.startsWith('414:'))?.substring(4) || '' : '';

  const handleSelection = (value, isOtherInput = false) => {
    setError('');
    let newSelection = [...selection];
    
    if (isOtherInput) {
      // Remove any existing "Other" entries and add new one with text
      newSelection = newSelection.filter(item => item !== '414' && !item.startsWith('414:'));
      newSelection.push(`414:${value}`);
    } else {
      if (value === '414') {
        // Handle "Other" selection
        if (selection.includes('414') || selection.some(item => item.startsWith('414:'))) {
          // Remove "Other" if already selected
          newSelection = newSelection.filter(item => item !== '414' && !item.startsWith('414:'));
        } else {
          // Add "Other" selection
          newSelection.push('414');
        }
      } else {
        // Handle regular options
        if (selection.includes(value)) {
          newSelection = newSelection.filter(item => item !== value);
        } else {
          newSelection.push(value);
        }
      }
    }
    setSelection(newSelection);
  };

  const handleContinue = () => {
    console.log('Selected Expenses:', selection);
    if (selection.length === 0) {
      setError('Please select at least one option.');
      return;
    }
    if (isOtherSelected && otherValue.trim() === '') {
      setError('Please specify your expense.');
      return;
    }
    setError('');
    onNext(selection);
  };

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Please tick any that apply</h2></div>
      <div className="qs-card__body">
        <ul className="qs-list">
          {Object.entries(ExpenseReengage).map(([key, value]) => {
            if (key === '414') {
              // Handle "Other" option with text input
              return (
                <li key={key} className="qs-list__item">
                  <div className="qs-other">
                    <button 
                      className={`qs-check qs-check--left ${isOtherSelected ? 'is-on' : ''}`} 
                      onClick={() => handleSelection('414')}
                    >
                      {value}
                    </button>
                    {isOtherSelected && (
                      <input
                        type="text"
                        className={`qs-input ${isOtherSelected ? 'is-show' : ''}`}
                        placeholder="Please specify:"
                        value={otherValue}
                        onChange={(e) => handleSelection(e.target.value, true)}
                      />
                    )}
                  </div>
                </li>
              );
            }
            return (
              <li key={key}>
                <button
                  className={`qs-check qs-check--left ${selection.includes(key) ? 'is-on' : ''}`}
                  onClick={() => handleSelection(key)}
                >
                  {value} {key === '413' && <span style={{ fontWeight: 400, color: '#6b7280' }}>(e.g., gas, electricity, water)</span>}
                </button>
              </li>
            );
          })}
        </ul>
        {error && <p className="qs-error-message" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        <div className="qs-actions"><button type="button" className="qs-btn qs-btn--primary" onClick={handleContinue} data-quest-id={135}>Continue <span className="qs-arrow">→</span></button></div>
      </div>
    </>
  );
};

export default AnyApply;
